module.exports = __webpack_public_path__ + "img/p3-bg.fd1595ee.webp";